import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { monitoredActivitiesApi, monitoredActivitySessionsApi } from '../api/monitoredActivities';

export const useMonitoredActivities = () => {
  return useQuery({
    queryKey: ['monitoredActivities'],
    queryFn: async () => {
      const res = await monitoredActivitiesApi.list();
      return res.data.monitored_activities;
    },
  });
};

export const useCreateMonitoredActivity = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => monitoredActivitiesApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['monitoredActivities'] }),
  });
};

export const useUpdateMonitoredActivity = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => monitoredActivitiesApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['monitoredActivities'] }),
  });
};

export const useDeleteMonitoredActivity = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => monitoredActivitiesApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['monitoredActivities'] }),
  });
};

export const useMonitoredActivitySessions = (status = 'completed') => {
  return useQuery({
    queryKey: ['monitoredActivitySessions', status],
    queryFn: async () => {
      const res = await monitoredActivitySessionsApi.list(status);
      return res.data;
    },
  });
};

export const useMonitoredActivitySession = (id) => {
  return useQuery({
    queryKey: ['monitoredActivitySession', id],
    queryFn: async () => {
      const res = await monitoredActivitySessionsApi.get(id);
      return res.data.monitored_activity_session;
    },
    enabled: !!id,
  });
};

export const useApproveMonitoredActivitySession = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => monitoredActivitySessionsApi.approve(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['monitoredActivitySessions'] }),
  });
};

export const useRejectMonitoredActivitySession = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => monitoredActivitySessionsApi.reject(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['monitoredActivitySessions'] }),
  });
};
